import React from 'react';
import {
  CreateButton,
  FilterLiveSearch,
  TopToolbar,
  usePermissions,
  useTranslate
} from 'react-admin';
import { PrivilegeType } from '../../../core/models/privileges/privilegeType';
import { some } from '../../../core/utils/collection-utils';

export const UsersListActions = () => {
  const t = useTranslate();
  const { permissions } = usePermissions();
  return (
    <TopToolbar>
      <FilterLiveSearch
        source="searchText"
        placeholder={t('resources.users.filters.search')}
      />
      {some([PrivilegeType.MANAGE_USERS], permissions) && <CreateButton />}
    </TopToolbar>
  );
};
